import { createFileRoute } from '@tanstack/react-router';
import App from '@generated/App';

// Home route ('/'). ?go=classifieds opens a section directly (used by links on star-revue.com).
// ?go=pay&amt=325&for=Joe%27s%20Pizza opens the pay page for a customer (link made by staff).
export const Route = createFileRoute('/_app/')({
  validateSearch: (search: Record<string, unknown>): { go?: string; amt?: string; for?: string } => ({
    go: typeof search.go === 'string' ? search.go : undefined,
    amt: typeof search.amt === 'string' || typeof search.amt === 'number' ? String(search.amt) : undefined,
    for: typeof search.for === 'string' ? search.for : undefined,
  }),
  component: App,
});
